import { render } from "./UnavailabilitiesCards.vue?vue&type=template&id=482365e0&ts=true"
import script from "./UnavailabilitiesCards.vue?vue&type=script&lang=ts"
export * from "./UnavailabilitiesCards.vue?vue&type=script&lang=ts"

import "./UnavailabilitiesCards.vue?vue&type=style&index=0&id=482365e0&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__